import type { TrailDefinition, TrailContext } from './types'

interface GlowOrb {
  x: number
  y: number
  life: number
  maxLife: number
  radius: number
}

const MAX_ORBS = 40

function hexToRgb(hex: string): [number, number, number] {
  const h = hex.replace('#', '')
  return [
    parseInt(h.substring(0, 2), 16),
    parseInt(h.substring(2, 4), 16),
    parseInt(h.substring(4, 6), 16)
  ]
}

export const glow: TrailDefinition = {
  id: 'glow',
  name: 'Glow',

  init() {
    return [] as GlowOrb[]
  },

  update(state: unknown, ctx: TrailContext) {
    const orbs = state as GlowOrb[]
    const dt = ctx.deltaTime / 1000

    // Spawn glow orbs at mouse
    if (ctx.mouseActive && dt > 0) {
      const spawnCount = Math.min(2, MAX_ORBS - orbs.length)
      for (let i = 0; i < spawnCount; i++) {
        orbs.push({
          x: ctx.mouseX + (Math.random() - 0.5) * 4,
          y: ctx.mouseY + (Math.random() - 0.5) * 4,
          life: 1,
          maxLife: 0.3 + Math.random() * 0.3,
          radius: 12 + Math.random() * 16
        })
      }
    }

    // Update
    for (let i = orbs.length - 1; i >= 0; i--) {
      const o = orbs[i]
      o.life -= dt / o.maxLife
      if (o.life <= 0) {
        orbs.splice(i, 1)
      }
    }
  },

  draw(state: unknown, ctx: TrailContext) {
    const orbs = state as GlowOrb[]
    const c = ctx.ctx
    const [r, g, b] = hexToRgb(ctx.primaryColor)

    // Lighter tint for inner glow
    const lr = Math.min(255, r + 80)
    const lg = Math.min(255, g + 80)
    const lb = Math.min(255, b + 80)

    for (const o of orbs) {
      const alpha = Math.max(0, o.life)
      const radius = o.radius * (1 - alpha * 0.3)

      const gradient = c.createRadialGradient(o.x, o.y, 0, o.x, o.y, radius)
      gradient.addColorStop(0, `rgba(${lr}, ${lg}, ${lb}, ${alpha * 0.35})`)
      gradient.addColorStop(0.4, `rgba(${r}, ${g}, ${b}, ${alpha * 0.15})`)
      gradient.addColorStop(1, 'transparent')

      c.fillStyle = gradient
      c.fillRect(o.x - radius, o.y - radius, radius * 2, radius * 2)
    }
  }
}
